import React from 'react';
import classnames from 'classnames/bind';
import { Divider } from 'taboola-ultimate-ui';
import { COMMON_FLAGS, useCommonConfig } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useWebSocket } from 'modules/taboola-common-frontend-modules/web-socket-provider/hooks/useWebSocket';
import { withFormDataProvider } from '../taboola-common-frontend-modules/formData';
import { EventsWrapper } from './components/EventsWrapper/EventsWrapper';
import { WebsiteWrapper } from './components/WebsiteWrapper/WebsiteWrapper';
import { pixelTesterInitialValues } from './config/pixelTesterInitialValues';
import { usePixelTesterData } from './hooks/usePixelTesterData';
import styles from './pixelTester.module.scss';

const classNameBuilder = classnames.bind(styles);

const PixelTesterForm = ({
    pixelTesterClassName,
    dividerClassname,
    containerClassName,
    eventsClassName,
    websiteClassName,
    websiteCollapsibleCardClassName,
    websiteCollapsibleCardHeaderClassName,
    showS2sOption,
}) => {
    const { processPixelTesterData } = usePixelTesterData();
    const { [COMMON_FLAGS.PIXEL_TESTER_WEBSOCKET_SOURCE_FILTER]: source } = useCommonConfig([
        COMMON_FLAGS.PIXEL_TESTER_WEBSOCKET_SOURCE_FILTER,
    ]);

    useWebSocket(
        data => {
            processPixelTesterData(data);
        },
        { sourceFilter: source }
    );

    return (
        <div className={classNameBuilder('pixel-tester', pixelTesterClassName)}>
            <Divider className={classNameBuilder('divider', dividerClassname)} />
            <div className={classNameBuilder('container', containerClassName)}>
                <div className={classNameBuilder('website-container', websiteClassName)}>
                    <WebsiteWrapper
                        websiteCollapsibleCardClassName={websiteCollapsibleCardClassName}
                        websiteCollapsibleCardHeaderClassName={websiteCollapsibleCardHeaderClassName}
                        showS2sOption={showS2sOption}
                    />
                </div>
                <div className={classNameBuilder('events-container', eventsClassName)}>
                    <EventsWrapper />
                </div>
            </div>
        </div>
    );
};

export const PixelTester = withFormDataProvider(PixelTesterForm, {
    defaultValuesConfig: pixelTesterInitialValues,
});
